// src/components/CustomerSummary/components/PayerMixTable.jsx
// ============================================================================
// BLOCK CS.UI.PAY.0 — PayerMixTable (read-only + resizable)
// ----------------------------------------------------------------------------
// Uses shared ResizableTextTable (single source of truth)
// INPUT FORMAT (tab-delimited; 3 columns)
//   <payer>\t<count>\t<percent>
// ============================================================================

import React from 'react';

import ResizableTextTable from './ResizableTextTable.jsx';
import { TABLE_FORMATS } from './tableFormats.js';

export default function PayerMixTable({ text, columnWidths, onColumnWidthsChange }) {
  return (
    <ResizableTextTable
      text={text}
      columnWidths={columnWidths}
      onColumnWidthsChange={onColumnWidthsChange}
      format={TABLE_FORMATS.payerMix}
    />
  );
}
